module.exports = __webpack_public_path__ + "static/5-4164d5890a1d317041b8489de2618a2d.jpg";